import Cogio from "../../../layouts/apps/Cogio";
import LinkedText from "../../../components/LinkedText";
import IconText from "../../../components/IconText";
import {faEnvelope, faHandHoldingMedical, faQuestionCircle} from "@fortawesome/free-solid-svg-icons";

export default function CogioSupport() {
    const rightContent = (
        <div>
            <h1><IconText icon={faHandHoldingMedical} text="Get Direct Help"></IconText></h1>
            <p>For technical issues, questions, or feature requests, contact me directly:</p>
            <LinkedText text={"cagri@mpospirit.com"} href={"mailto:cagri@mpospirit.com"} icon={faEnvelope}></LinkedText>

            <h1><IconText icon={faQuestionCircle} text={"FAQ"}></IconText></h1>
            <h3>Q: How do I install Cogio?</h3>
            <p>Using Apple App Store.</p>
            
            <h3>Q: Do I need to be online to use Cogio?</h3>
            <p>No, Cogio works completely offline after installation.</p>

            <h3>Q: Is my data private?</h3>
            <p>Yes, all your data is stored locally on your device and never sent to any servers.</p>

            <h3>Q: What is an SQLite database?</h3>
            <p>It's a lightweight database format that stores data in a single file on your device.</p>

            <h3>Q: Can I get a free copy of Cogio?</h3>
            <p>Yes you can. Send me an email explaining why you need a free copy and I'll get back to you.</p>
        </div>
    );

    return (
        <div className="cogio-support-page">
            <Cogio rightContent={rightContent}/>
        </div>
    )
}